import React from "react";
import { formatMoney, formatTime } from "@/lib/format";
import { PlusCircle, MinusCircle, Wallet, Receipt, ArrowDownCircle, ArrowUpCircle, Lock } from "lucide-react";

const ICONS = {
  opening: Wallet, payment: PlusCircle, expense: Receipt,
  movement_pos: ArrowDownCircle, movement_neg: ArrowUpCircle, closing: Lock,
};

export function CashTimeline({ events, currency }) {
  if (!events?.length) return <p className="text-sm text-slate-400">Aucune activité.</p>;
  return (
    <div className="space-y-1" data-testid="cash-timeline">
      {events.map((e, i) => {
        const positive = (e.amount_cents || 0) >= 0;
        let Icon = ICONS[e.kind] || PlusCircle;
        if (e.kind === "movement") Icon = positive ? ICONS.movement_pos : ICONS.movement_neg;
        return (
          <div key={i} data-testid={`cash-timeline-event-${i}`} className="flex items-center gap-3 rounded-lg px-2 py-2 hover:bg-slate-50">
            <div className={`flex h-8 w-8 flex-none items-center justify-center rounded-full ${positive ? "bg-emerald-50 text-emerald-600" : "bg-rose-50 text-rose-600"}`}>
              <Icon className="h-4 w-4" />
            </div>
            <div className="min-w-0 flex-1">
              <p className="truncate text-sm font-medium text-slate-800">{e.label}</p>
              <p className="truncate text-xs text-slate-400">
                {formatTime(e.at)}{e.actor ? ` · ${e.actor}` : ""}{e.method ? ` · ${e.method}` : ""}{e.reason ? ` · ${e.reason}` : ""}
              </p>
            </div>
            {e.kind !== "closing" && (
              <span className={`flex-none font-mono text-sm font-semibold ${positive ? "text-emerald-700" : "text-rose-700"}`}>
                {positive ? "+" : "−"}{formatMoney(Math.abs(e.amount_cents || 0), currency)}
              </span>
            )}
          </div>
        );
      })}
    </div>
  );
}
